export default __webpack_public_path__ + "static/media/Poppins-Black.5d04762a.woff";